import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UserPointsType from 'components/molecules/user-points-type';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
// import CptPositionStacking from 'components/organisms/cpt-position-stacking';
import OptimizeButton from 'components/molecules/optimize-button';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import ProjectedOwnershipForce from 'components/organisms/projected-ownership-force';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import SinglegameForcedStacking from 'components/organisms/singlegame-forced-stacking';
import StackQuarterbackWithPassReceivers from 'components/molecules/stack-quarterback-with-pass-receivers';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import PlayerPositionStacking from 'components/organisms/player-position-stacking';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';
import AllowOnlyOneKPositionPerLineup from 'components/molecules/limit-position-per-lineup/allow-only-one-K-position-per-lineup';
import AllowOnlyOneDSTPositionPerLineup from 'components/molecules/limit-position-per-lineup/allow-only-one-DST-position-per-lineup';

class PlayersDashboardComponent extends Component {
    render() {
        const {sportConfig, playersFilter} = this.props;

        const maxUniquePlayers = sportConfig.getPlayersInTeam() - 1;

        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary
                                key={`sr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <FilterByPoints
                                key={`pr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <SelectSalaryCap useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType
                                options={{
                                    sharpPoints: 'Props Projection',
                                    ceilingPoints: 'Ceiling Projection',
                                    adminPoints: 'Projection',
                                }}
                            />
                            <UniquePlayersQuantity max={maxUniquePlayers} />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <ProjectedOwnershipForce />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <StackQuarterbackWithPassReceivers />
                        </div>
                        <div className="filters-cell">
                            <AllowOnlyOneKPositionPerLineup />
                        </div>
                        <div className="filters-cell">
                            <AllowOnlyOneDSTPositionPerLineup />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'nfl'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <SinglegameForcedStacking />
                {/*<CptPositionStacking/>*/}
                <PlayerPositionStacking />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {
            filters,
        },
    } = state;

    return {
        sportConfig,
        playersFilter: filters,
    };
}

const PlayersDashboard = connect(mapStatesToProps)(PlayersDashboardComponent);

export {PlayersDashboard};
